import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';

export const useDeleteApplicationList = (applicationListId: string) => {
  const queryClient = useQueryClient();

  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: () =>
      apiRequest<void>({
        method: 'DELETE',
        url: `${apiHost}/application-lists/${applicationListId}`,
      }),
    onSuccess: (applicationListId) => {
      queryClient.invalidateQueries({
        queryKey: ['applicationList', applicationListId],
      });
    },
  });
};
